import { ModalCreateTeamView } from '@modules/settings/team-management/components/modal-create-team-view';
import { useCreateTeam } from '@modules/settings/team-management/hooks/use-create-team';
import { capitalize } from '@shared/utils/capitalize';
import { useTranslation } from 'react-i18next';
import { useUserRole } from '@shared/hooks/use-user-role';
import { Button } from 'antd';
import clsx from 'clsx';
import { RiAddLine } from 'react-icons/ri';
import { AccessControlledWrapper } from '@components/plan-role-access-control-wrapper/access-controlled-wrapper';

type Props = {
  isOverlay?: boolean;
};

export function AddTeam({ isOverlay }: Props) {
  const { t } = useTranslation();
  const {
    openAddModal,
    handleOpenAddModal,
    handleCloseAddModal,
    addTeamControl,
    handleCreateTeamSubmit,
    createTeamLoading,
  } = useCreateTeam();

  const userRole = useUserRole();
  const canAddTeam = !userRole?.isMember;

  return (
    <div
      className={clsx(isOverlay ? 'h-9' : 'h-5.5')}
      onKeyDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <AccessControlledWrapper hasRoleAccess={canAddTeam} tooltip={capitalize(t('add_team'))}>
        <Button
          type="text"
          size="small"
          disabled={!canAddTeam}
          className={clsx(
            isOverlay ? 'size-9! rounded-full!' : 'p-0! min-w-0! h-auto! leading-none! text-text-600 -translate-y-1!'
          )}
          onClick={handleOpenAddModal}
        >
          <RiAddLine className="size-5" />
        </Button>
      </AccessControlledWrapper>
      <ModalCreateTeamView
        isOpen={openAddModal}
        closeModal={handleCloseAddModal}
        control={addTeamControl}
        onSubmit={handleCreateTeamSubmit}
        loading={createTeamLoading}
      />
    </div>
  );
}
